import { render, staticRenderFns } from "./waitReject.vue?vue&type=template&id=43bf85aa"
import script from "./waitReject.vue?vue&type=script&lang=js"
export * from "./waitReject.vue?vue&type=script&lang=js"
import style0 from "./waitReject.vue?vue&type=style&index=0&id=43bf85aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports